import KH1000100003 from "./BodABC";
import KH1000150008 from "./BodDBDE";
import KH1000020003 from "./BodGIT";
import KH1000160007 from "./BodJSL";
import KH1000060009 from "./BodPAS";
import KH1000140009 from "./BodPEPC";
import KH1000040001 from "./BodPPAP";
import KH1000050000 from "./BodPPSP";
import KH1000010004 from "./BodPWSA";
import KH1000220009 from "./BodCGSM";
import KH1000210000 from "./BodMJQE";

export default function Bod({ icode }) {
  if (icode === "KH1000100003") {
    return <KH1000100003></KH1000100003>;
  } else if (icode === "KH1000150008") {
    return <KH1000150008></KH1000150008>;
  } else if (icode === "KH1000020003") {
    return <KH1000020003></KH1000020003>;
  } else if (icode === "KH1000160007") {
    return <KH1000160007></KH1000160007>;
  } else if (icode === "KH1000060009") {
    return <KH1000060009></KH1000060009>;
  } else if (icode === "KH1000140009") {
    return <KH1000140009></KH1000140009>;
  } else if (icode === "KH1000040001") {
    return <KH1000040001></KH1000040001>;
  } else if (icode === "KH1000050000") {
    return <KH1000050000></KH1000050000>;
  } else if (icode === "KH1000010004") {
    return <KH1000010004></KH1000010004>;
  } else if (icode === "KH1000220009") {
    return <KH1000220009></KH1000220009>;
  } else if (icode === "KH1000210000") {
    return <KH1000210000></KH1000210000>;
  }
}
